import { useEffect, useState } from "react";
import api from "@/lib/api";
import { safeJsonLd } from "@/lib/safeJson";
import SmoothScroll from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import TopMarquee from "@/components/site/TopMarquee";
import Hero from "@/components/site/Hero";
import LatestSlider from "@/components/site/LatestSlider";
import NarmadapuramGrid from "@/components/site/NarmadapuramGrid";
import MPGrid from "@/components/site/MPGrid";
import NationalGrid from "@/components/site/NationalGrid";
import DenvaExclusive from "@/components/site/DenvaExclusive";
import VideoSection from "@/components/site/VideoSection";
import CategoryBlock from "@/components/site/CategoryBlock";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Newsletter from "@/components/site/Newsletter";
import AdSlot from "@/components/site/AdSlot";
import PopupAd from "@/components/site/PopupAd";
import RajkajExternalBlock from "@/components/site/RajkajExternalBlock";
import Footer from "@/components/site/Footer";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "NewsMediaOrganization",
  name: "Denva Post",
  alternateName: "देनवा पोस्ट",
  url: "https://denvapost.com",
  logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_denva-press/artifacts/0mtpvuj1_df722c62173c41a893d7b83952155c17.png",
  inLanguage: "hi-IN",
  areaServed: ["Narmadapuram Division", "Madhya Pradesh", "India"],
};

const AdStrip = ({ testid }) => (
  <div className="bg-[#F4F4F0] border-b border-[#0F0F0F]/10">
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-6">
      <AdSlot variant="leaderboard" testid={testid} />
    </div>
  </div>
);

export default function PublicHome() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/public/homepage").then((r) => setData(r.data)).catch(() => setData(null));
    if (window.posthog) { try { window.posthog.capture("home_view"); } catch (_) {} }
  }, []);

  const s = data?.sections || {};

  return (
    <SmoothScroll>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJsonLd(SCHEMA) }} />
      <div className="App font-sans-dev" data-testid="denva-home">
        <TopMarquee />
        <Header />
        <main>
          <Hero hero={data?.hero} teasers={s.narmadapuram?.slice(1, 4)} />
          <LatestSlider items={data?.latest} />
          <NarmadapuramGrid items={s.narmadapuram} />
          <AdStrip testid="ad-1" />
          <MPGrid items={s.mp} />
          <DenvaExclusive items={data?.exclusive} />
          <CategoryBlock id="edujobs" kicker="Education & Jobs" title="शिक्षा-रोजगार" items={s.edujobs} variant="cards" tint={false} moreLabel="सभी अवसर" />
          <RajkajExternalBlock />
          <AdStrip testid="ad-2" />
          <CategoryBlock id="utility" kicker="Useful" title="काम की बात" items={s.utility} variant="cards" tint={false} moreLabel="और उपयोगी" />
          <CategoryBlock id="politics" kicker="Politics" title="राजनीति" accent="की धुरी" items={s.politics} variant="leadList" tint={true} moreLabel="सियासी ख़बरें" />
          <NationalGrid items={s.national} />
          <VideoSection videos={data?.videos} />
          <CategoryBlock id="sportsent" kicker="Sports & Entertainment" title="खेल-मनोरंजन" items={s.sportsent} variant="cards" tint={false} moreLabel="और मनोरंजन" />
          <CategoryBlock id="religion" kicker="Faith & Culture" title="धर्म संस्कृति" items={s.religion} variant="cards" tint={true} moreLabel="आस्था की ख़बरें" />
          <About />
          <Newsletter />
          <Contact />
        </main>
        <PopupAd />
        <Footer />
      </div>
    </SmoothScroll>
  );
}
